export enum AddressCombination {
  ONLY_DELIVERY,
  ONLY_BILLING,
  BOTH, //Wenn beide Adressen abgefragt werden sollen
  NONE //Wenn keine Adressen abgefragt werden sollen
}
